<div *ngIf="visible" id="invitation-template-selector" class="form-field required">
  <label>Modèle d'invitation</label>
  <select (ngModelChange)="onChangeInvitationTemplate($event)"
          [ngModel]="currentInvitationTemplate"
          class="form-control custom-select fs14px">
    <option [ngValue]="defaultInvitationTemplate">Modèle prédéfini</option>
    <option [ngValue]="emptyInvitationTemplate">Nouveau modèle vierge</option>
    <option *ngIf="invitationsTemplates && invitationsTemplates.length > 0" disabled> ─────────────────── </option>
    <option *ngFor="let t of invitationsTemplates" [ngValue]="t">Modèle n°{{t.id}}</option>
  </select>
</div>

<div *ngIf="visible" id="invitation-template-text" class="form-field required">
  <label>Texte d'invitation</label>
  <textarea (ngModelChange)="onChangeInvitationTemplateContent($event)"
            [class.is-invalid]="currentInvitationTemplate.content.length === 0"
            [maxRows]="maxRows"
            [minRows]="minRows"
            [ngModel]="currentInvitationTemplate.content"
            aria-describedby="content"
            autosize
            class="form-control"
            id="invitation-textarea"
            placeholder="Écrivez le texte d'invitation"
            type="text"></textarea>

  <small class="grey2">
    {{
    currentInvitationTemplate.id.toValue() === -1
    ? 'Le modèle sera sauvegardé et utilisé dans le message envoyé.'
    : 'Les modifications seront utilisées dans le message envoyé, mais ne seront pas sauvegardées.'
    }}
  </small>

  <textarea [disabled]="true"
            [ngModel]="sign"
            rows="3"
            style="overflow:hidden"
            class="form-control mt-2"
            type="text">
  </textarea>

  <small class="grey2">Ce texte n'est pas modifiable et terminera toujours vos modèles d'invitation.</small>
</div>
